import debounce from 'lodash/debounce';
// There is known issue with async functions passed to debounce
// https://github.com/lodash/lodash/issues/4700
export const asyncDebounce = (func, wait) => {
    const debounced = debounce((resolve, reject, args) => {
        func(...args)
            .then(resolve)
            .catch(reject);
    }, wait);
    return (...args) => new Promise((resolve, reject) => {
        debounced(resolve, reject, args);
    });
};
